<template>
  <div class="faq-section critical-component-clear">
    <div class="container grid">
      <div class="col xs-span l4-9">
        <div
          v-if="liquid.sectionTitle || liquid.sectionSubtitle"
          class="faq-section__header"
        >
          <h2
            v-if="liquid.sectionTitle"
            :id="`section-title-${liquid.sectionId}`"
            class="faq-section__title text-mobile-headlines-h3 text-desktop-headlines-h3"
            v-text="liquid.sectionTitle"
          />

          <p
            v-if="liquid.sectionSubtitle"
            class="faq-section__subtitle text-mobile-paragraph-m-regular text-desktop-paragraph-m-regular"
            v-text="liquid.sectionSubtitle"
          />
        </div>
        <accordion-snippet
          v-show="panels"
          block-class="faq-section"
          heading-type="span"
          content-modifier-classes="
            text-mobile-paragraph-m-regular
            text-desktop-paragraph-m-regular
          "
          heading-modifier-classes="
            text-mobile-paragraph-m-bold
            text-desktop-paragraph-m-bold
          "
          :panel-data="panels"
          :active-panels="activePanels"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Vue: FAQ Section (faq-section)
 * -----------------------------------------------------------------------------
 * Expandable text section to display frequently asked questions.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {String} liquid.sectionTitle - Section setting title.
 * @param {String} liquid.sectionSubtitle - Section setting subtitle.
 * @param {Object} panels - Panel data.
 * @param {String} activePanels - activePanels data.
 *
 */
import AccordionSnippet from '~async/accordion-snippet/accordion-snippet';

export default {
  name: 'FaqSection',

  components: {
    AccordionSnippet,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        sectionTitle: '',
        sectionSubtitle: '',
      }),
    },
    panels: {
      type: Object,
      default: () => ({
        content: '',
        title: '',
      }),
    },
    activePanels: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
@import './faq-section';
</style>
